/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.recommendations.rpc.ranked.RankedRecommendationService
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const getRecommendationsRpc = {
  serviceName: 'com.hubspot.academy.recommendations.rpc.ranked.RankedRecommendationService',
  rpcName: 'getRecommendations',
  auth: 'app',
  fingerprint: 'MKPnF9EaLr3HG0LDlYj6N5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const registerFeedbackRpc = {
  serviceName: 'com.hubspot.academy.recommendations.rpc.ranked.RankedRecommendationService',
  rpcName: 'registerFeedback',
  auth: 'app',
  fingerprint: 'FG8t0D8sYsuOUe2e_r4XmZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const registerContentEngagementRpc = {
  serviceName: 'com.hubspot.academy.recommendations.rpc.ranked.RankedRecommendationService',
  rpcName: 'registerContentEngagement',
  auth: 'app',
  fingerprint: 'ehZCga_mc7iOUe2e_r4XmZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};